// js/shared/public-field.js: the public forms' field error, in one place.
// Queue item KVb.
//
// Queue item KV built the home page's contact form error (E-04, E-12): a
// message AT the field, in its own `.kaf-field-error` line, with
// aria-invalid on the control (public/styles/public.css draws both). Queue
// item KVb gives /for-trainers' waitlist the same error (E-38), so the
// helper moved here and both pages call it: js/shared/public-home.js and
// js/shared/for-trainers.js. Nothing in this file boots; importing it does
// not run either page.
//
// The markup each field carries (the control already names the error line in
// its aria-describedby, so a screen reader reads the message with the field):
//   <div class="kaf-field">
//     <label class="kaf-field-label" for="x">…</label>
//     <input id="x" aria-describedby="x-err">
//     <p class="kaf-field-error" id="x-err" hidden></p>
//   </div>

/** The first word of a name, for "Got it, Grace." and "Thanks, Grace." */
export function firstName(name) {
  return String(name || '').trim().split(/\s+/)[0] || '';
}

/**
 * The document title while a form shows errors: "Error: " before the page's
 * own title (GOV.UK's pattern, so a screen reader hears the page failed
 * before anything else). `on` false gives the title back unchanged.
 */
export function errorTitle(base, on, prefix = 'Error: ') {
  const b = String(base || '');
  const clean = b.startsWith(prefix) ? b.slice(prefix.length) : b;
  return on ? prefix + clean : clean;
}

/**
 * Show `message` at one `.kaf-field` (aria-invalid on its control, the words
 * in its `.kaf-field-error` line), or clear both when `message` is empty.
 */
export function setFieldError(field, message) {
  if (!field) return;
  const control = field.querySelector('input, select, textarea');
  const line = field.querySelector('.kaf-field-error');
  if (message) {
    if (control) control.setAttribute('aria-invalid', 'true');
    if (line) { line.textContent = message; line.hidden = false; }
  } else {
    if (control) control.removeAttribute('aria-invalid');
    if (line) { line.textContent = ''; line.hidden = true; }
  }
}
